import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();

    if (loading || user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-slate-50">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" />
            </div>
        );
    }

    if (!user) return <Navigate to="/login" replace />;

    // v1.27.73 — Staff sub-users share the admin UI. Treat them as admin
    // for route protection; the backend + AdminLayout enforce their
    // narrower permission set.
    const effectiveRole = user.role === "staff" ? "admin" : user.role;

    if (role && effectiveRole !== role) {
        return <Navigate to={effectiveRole === "admin" ? "/admin" : "/portal"} replace />;
    }

    return children;
}
